module.exports = __webpack_public_path__ + "img/avatar.21b2e55d.png";